import React, { useState } from "react";
import {Alert} from "../../../controls";

const CustomerSelectDialogValidator = (props) => {
  const companyUuid = props.companyUuid;

  const [state, setState] = useState({

    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (companyUuid && !companyUuid.found) {
    error = true;
    errorMessage = "Please select a valid 'Airport'";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert
      open={state.error}
      severity="error"
      canClose={false}
      message={state.errorMessage ? state.errorMessage : ""}
    />
  );

}

export default CustomerSelectDialogValidator;